<button class="cursor-pointer bg-warning px-5 py-2 rounded text-center drop-shadow-lg w-72">
  <fa-icon [icon]="faWrench" class="pr-1.5"></fa-icon>
  Manage in Admin Panel
</button>
